<template>
    <van-popup
      v-model="value"
      get-container="body"
      :class="['global_popup',{'other_popup': noheader},{'front_popup': front},{'wide': selection&&selection.wide?selection.wide:false}]"
      :close-on-click-overlay="true"
      :overlay-class="front? 'front_overlay': ''">
      <div class="close_btn" @click="closeModal" v-if="!noheader"></div> 
      <div class="title" v-if="!noheader">{{ title }}</div>   
      <FormTemplate
        ref="template"
        :selection="selection"
        @fail="handleFail"
        @error="handleError"
        @success="handleSuccess"
        @closeModal="closeModal"></FormTemplate>
    </van-popup>
  </template>
  
  <script>
  import $ from 'jquery'
  export default {
    data () {
      return {
        timer: null,
        value: false,
      }
    },
    props: {
      title: String,
      onSuccess: Function,
      onError: Function,
      // 传递给子组件
      selection: Object,
      noheader: Boolean,
      front: Boolean
    },
    computed: {

    },
    methods: {
      closeModal() {
        this.value = false
      },
      handleFail (reason) {
        if (typeof reason === 'string') this.$toast(reason)
        this.value = false
      },
      handleError (data) {
        if (this.onError) this.onError(data)
      },
      handleSuccess (data) {
        if (this.onSuccess) this.onSuccess(data)
        this.value = false
      },
      // 销毁实例并移除元素
      destroyElement () {
        if (this.timer) {
          window.clearTimeout(this.timer)
          this.timer = null
        }
        this.$destroy(true)
        $('body').remove('.global_popup')
      }
    },
    watch: {
      value (bool) {
        if (!bool) {
          this.timer = window.setTimeout(this.destroyElement, 300)
        }
      },
      '$route.name': {
        immediate: true,
        handler() {
          this.value = false
        },
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .global_popup {
    width: 93%;
    top: 40%;
    max-width: 400px;
    background-color: #fff;
    border-radius: 0.4rem;
    padding-bottom: 2rem;
    &.other_popup {
      top: 50%;
      width: 29.2rem;
      padding: 0;
      border-radius: 1.5rem;
    }
    &.front_popup {
      z-index: 100000 !important;
      top: 40%;
    }
    &.wide {
      width: 32rem;
    }
    .close_btn {
        position: absolute;
        top: 1.2rem;
        right: 1.2rem;
        width: 1.8rem;
        height: 1.8rem;
        cursor: pointer;
        &::before,
        &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: .2rem;
            height: 2.4rem;
            background-color: var(--fade5);
        }
        &::before {
            transform: translate(-50%,-50%) rotate(45deg);
        }
        &::after {
            transform: translate(-50%,-50%) rotate(-45deg);
        }
    }
    .title {
        height: 4rem;
        line-height: 4rem;
        text-align: center;
        font-size: 1.7rem;
    }
  }
  </style>
  